module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "t005"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter Two")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OW ENTERING ORBIT")]), _vm._v(" around Archaria III, Captain,” Geordi La Forge reported from the helm, his voice rising above the electronic whirs, beeps, and chirps that signified that all systems were operating at full efficiency. When the young lieutenant glanced over his shoulder, Picard saw the bridge lights gleam across the metallic visor that covered his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On the viewscreen.” Picard leaned forward, anxious to see this troubled little world. “Standard orbit, Mr. La Forge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aye, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Archaria III appeared on the main viewscreen at the front of the bridge. It was a lush planet, half water and half land, with swirls of white clouds covering the northern hemisphere. The three main"), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v(" continents—colored in rich browns and greens, dotted with picturesque lakes and long flowing rivers—looked like a paradise to him. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("And what have they done with it,")]), _vm._v(" he thought bitterly. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("They busy themselves squabbling over genetic purity.")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometimes he just wanted to grab planet-bound people by the scruff of the neck, drag them into orbit, and force them to gaze in wonder at the worlds they called home. If they could only see the hugeness of the universe, or realize just how insignificant they were in the greater cosmic vastness, it might well knock some sense into them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The comm system beeped urgently. Beside Lieutenant La Forge, Ensign Cherbach touched his controls and reported, “We are being hailed, sir. Governor Sekk wishes to speak with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("So it begins.")]), _vm._v(" With a mental sigh, Picard dragged himself back from his reverie. Standing, he pulled his uniform straighter and took a step forward. He wasn’t looking forward to this conversation, but it had to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On screen,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aye, sir.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The controls beeped softly in response, and the image of a balding, stocky man with a chest-length gray beard replaced the splendid view of the planet. Dark circles lined Governor Sekk’s eyes, and deep worry lines creased his forehead. His ceremonial robes appeared rumpled and unkempt; several slight but noticeable food stains marked the front. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("A good man pushed too hard,")]), _vm._v(" was Picard’s immediate reaction. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I don’t think he’s slept in days.")]), _vm._v(" Clearly")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v(" Sekk took the plague, the Purity League, and all the attendant problems quite seriously.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("As does Starfleet,")]), _vm._v(" Picard thought grimly. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("As do we all.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even in the midst of crisis, protocol had to be observed. Picard inclined his head and got the niceties under way: “I am Captain Jean-Luc Picard of the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Enterprise.")]), _vm._v(" Governor Sekk, I presume?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Captain.” Sekk’s voice was hoarse, Picard noticed. Too many orders over too many hours? Too many speeches to try to keep up morale? “Thank you for coming so quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at all, Governor. I understand the situation is still quite dire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sekk nodded. “Our morgues and hospitals are overflowing. There are fifteen thousand reported cases of the plague to date, with more being reported by the hour. Officially we now have more than ten thousand dead. Our cities are being abandoned. There are riots in the streets.” His voice rose an octave. “We must have immediate help!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, Governor. We have sufficient supplies of Tricillin PDF aboard to last your doctors for several weeks. The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Constitution")]), _vm._v(" is bringing additional supplies and should arrive shortly. If your people will provide the necessary coordinates, our transporter rooms will begin beaming the drug down immediately.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, Captain.” He motioned urgently to someone Picard couldn’t see. “One of my aides will get the information for you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“My ship’s medical staff is standing by to work")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v(" with your doctors,” Picard went on. “Any help they can provide will be given immediately. I believe Dr. Crusher, my chief medical officer, is already in contact with Dr. Tang at Archo City Hospital. I understand he is in charge of your efforts to find a cure.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right, Tang is a good man. A very good man. Our best researcher.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard licked his lips. Now came the delicate part. The part he knew Sekk wouldn’t like … and which he himself hated to have to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Governor Sekk,” he began, “as you can well imagine, the virulent nature of this disease has alarmed many of your neighboring star systems as well as Starfleet. All outbound ships have been ordered back to Archaria III. I am afraid I must place your planet under a quarantine, at least for the time being. No one may enter or leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sekk seemed to shrink a little into himself. To an agricultural planet like Archaria III, quarantine would be viewed as nothing short of an economic death sentence; unless their grains and other foodstuffs were shipped out to market promptly, Archaria III’s economy would begin to stagger and fail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the protests Picard expected never came. Governor Sekk only nodded wearily, as if he had been expecting it all along. “Very well, Captain. I will inform our spaceport at once. No more ships will be allowed to depart without Starfleet’s approval.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Picard nodded. “Good.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Perhaps this won’t be so difficult after all. If this is the level of cooperation I")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v(" can expect, we should have the situation well in hand in just a few days.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is there anything else you need?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to see a log of all outbound ships for the last three months, Governor, with flight plans. Plus passenger lists and complete cargo manifests. If any ships have to be chased down, we had best get started.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. The information is online with our spaceport’s computers. I will make certain you have immediate access.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you.” Picard hesitated a second. Sekk clearly "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" a good man, and his cooperation would undoubtedly come at a high personal price: after such a series of disasters—plague, planetary quarantine, economic ruin—he would stand little chance of being reelected planetary governor again. At least he could throw the man one little sop … something that might lead to a position within Starfleet’s bureaucracy if Sekk followed up on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want you to know,” Picard finally said, “that your assistance in this matter will not go unnoticed. I will personally see to it that your name is mentioned prominently in my reports to Starfleet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sekk nodded. “Thank you, Captain. But I would prefer your attentions go where they are most needed. Find a cure for the plague. Get the quarantine lifted. Help my people. That’s all I really need.” His smile was that of a kindly, benevolent ruler.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("And a dozen red flags went up in Picard’s mind. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("He’s hiding something.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard returned that winning smile. “Understood, Governor. Thank you for your assistance. Picard out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Returning to his command seat, he sat back and crossed his legs. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("He’s lying to me. Somehow, some way, he thinks he’s pulled the wool over my eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He paused and thought, focusing not on the governor but on the people around him, trying to dredge some unvoiced suspicion from his subconscious. Officers hurried from station to station, scanning the planet and the rest of the system. The doors whooshed open as two more science officers came onto the bridge. The familiar chirps and beeps of the bridge filled his ears, along with the softer underlying bass vibration of a ship in orbit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard retraced his conversation word by word, detail by detail. It "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("seemed")]), _vm._v(" straightforward enough. Yet Sekk’s all-too-convenient cooperation suddenly smelled wrong. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Why?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The answer suddenly came to him: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("So we won’t suspect the data he provides.")]), _vm._v(" Clearly the governor wanted to hide something. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("But what?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any thoughts, Number One?” he asked suddenly. He glanced at his second in command, still seated to his immediate right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think he’s playing us for fools, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard covered his inner smile. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Riker will make a good captain someday. He’s got the instincts for it.")]), _vm._v(" “Fools, eh?” he said. “Would you care to elaborate?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Riker hesitated. “I’m not sure, sir. I can’t quite put my finger on it…. ”")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" can. I’ll wager the governor sent his family off-planet in a private ship and doesn’t want them sent back here. And I will be "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("very")]), _vm._v(" surprised if we find a single reference to it in the spaceport’s records.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riker looked puzzled. “How did you know—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No career politician would surrender power so easily, Number One, and then refuse to take credit for it.” He smiled a little grimly, thinking about the first time he had negotiated with the governor of a planet. He had been a lieutenant then, and Governor Silas Jones of the Rigel Colony had eaten him alive. “Sekk made one fatal mistake when he gave that stirring little speech about putting his people first.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riker shook his head sadly. “Which is, of course, what a leader is supposed to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but it was too easy, as if he would have turned things around so it looked like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("he")]), _vm._v(" gave us the records—in the best interest of his people, of course. Instead, he let me do all the work, then distanced himself from it. This way he hasn’t lied or obstructed us in any way if the truth "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("does")]), _vm._v(" come out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s always one bad apple,” Riker sighed. “Still, hopefully there are other people on this on more than their own planet who can focus interests.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("It’s nice to have an idealist for a first officer, Picard thought. I know the Federation’s philosophy will always be supported.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir,” said La Forge, swiveling in his seat. “I have an idea of where we can find that extra ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly Picard nodded. He liked initiative, and Geordi La Forge was another crewman who had the right instincts … and almost certainly could look forward to a long and distinguished career in Starfleet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then it’s your baby, Mr. La Forge,” he said, settling back in his seat. “Proceed when ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard glanced at Riker again. “And now, Number One, don’t you have an away mission to plan?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riker said, “It’s well in hand, sir. Most of the Purity League’s activities take place under the cover of darkness. We will be beaming down at dusk, and Lieutenant Yar is currently scouting the most likely spot to encounter them. I have already ordered native garb for the three of us. We will be ready on schedule.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excellent.” Picard took a deep breath. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Like clockwork,")]), _vm._v(" he thought with satisfaction. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("A good ship runs like clockwork.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An ensign appeared at his elbow holding a duty roster. After scanning the list of names, he signed off on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir,” said La Forge. “We have the spaceport’s departure records now. Request permission to use the computer station in astrometrics for my research.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Astrometrics?”")]), _vm._v(" Picard raised his eyebrows")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v(" slightly. It seemed an odd request. “Is there some reason you need access to interstellar charting, Mr. La Forge?”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a theory about the governor’s secret ship, sir. Call it … a hunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard thought it over a heartbeat. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Give him a chance. Let him prove himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very well,” he said. Hunches often had a grain of logic to them, even if the conscious mind couldn’t always pin it down. “Carry on, Mr. La Forge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir.” All business, the lieutenant rose and strode from the bridge with apparent confidence and determination. Ensign Charles Ehrhart moved forward to take La Forge’s place at the navigator’s station.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Like clockwork,")]), _vm._v(" Picard thought, leaning back and smiling to himself. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Excellent.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34c12947","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/005.vue
// module id = 78
// module chunks = 0